import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListAvailableTimeframesActions } from "store/ducks/transports";

export function* listAvailableTimeframesRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(
      api.get,
      `/find-available-timeframes?${queryString}`
    );

    yield put(ListAvailableTimeframesActions.success(data.docks));
    if (onSuccess) onSuccess(data.docks);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListAvailableTimeframesActions.failure(errorMessage));
	const { onSuccess } = action as IListRequest;
	// yield put(ListAvailableTimeframesActions.success({docks:[]}));
	if (onSuccess) onSuccess([]);
  }
}
